import ParameterErrors from '../errors/ParameterErrors';
import BrochureProgressStatus from '../enums/BrochureProgressStatus';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
const {throwNotProvided}=ParameterErrors;
export default class BrochureBeingGenerated{
	constructor(params){
		enableAcceptBindings(this);
		let {brochureGenerationIdentifier, brochureProgressStatus, plotNumbers, brochureUrl, brochureType} = params;
		if(brochureGenerationIdentifier===undefined||brochureGenerationIdentifier===null)
			throwNotProvided('brochureGenerationIdentifier');
		this._brochureGenerationIdentifier = brochureGenerationIdentifier;
		if(brochureProgressStatus===undefined||brochureProgressStatus===null)
			brochureProgressStatus=BrochureProgressStatus.Queued;
		this._brochureProgressStatus = brochureProgressStatus;
		this._proportionProgress = 0;
		this._brochureUrl=brochureUrl;
		this._brochureType = brochureType;
		this._plotNumbers = plotNumbers;
		this.updateProgress= this.updateProgress.bind(this);	
		exposeBinding(this, 'brochureProgressStatus', ()=>this._brochureProgressStatus, (value)=>this._brochureProgressStatus = value);
		exposeBinding(this, 'proportionProgress', ()=>this._proportionProgress, (value)=>this._proportionProgress = value);
		exposeBinding(this, 'brochureUrl', ()=>this._brochureUrl, (value)=>this._brochureUrl = value);
	
	}
	get brochureProgressStatus(){
		return this._brochureProgressStatus;
	}
	get brochureGenerationIdentifier(){
		return this._brochureGenerationIdentifier;
	}
	get proportionProgress(){
		return this._proportionProgress;
	}
	get brochureType(){
		return this._brochureType;
	}
	get brochureUrl(){
		return this._brochureUrl;
	}
	get plotNumbers(){
		return this._plotNumbers;
	}
	updateProgress(progress){
		if(this._brochureProgressStatus !== progress.brochureProgressStatus){
			this._brochureProgressStatus = progress.brochureProgressStatus;
			this.bindingsHandler.changed('brochureProgressStatus', this.brochureProgressStatus);
		}
		
		if(progress.proportionProgress!==undefined&&progress.proportionProgress!==null
		    &&this._proportionProgress !== progress.proportionProgress){
			this._proportionProgress = progress.proportionProgress;
			this.bindingsHandler.changed('proportionProgress', this.proportionProgress);
		}
		
		if(progress.brochureUrl!==undefined&&progress.brochureUrl!==null
			&&this._brochureUrl !== progress.brochureUrl){
			this._brochureUrl = progress.brochureUrl;
			if(this._brochureUrl)
				this.bindingsHandler.changed('brochureUrl', this.brochureUrl);
		}
	}
}